import { Dictionary } from "./dictionary.model";

export class UrlBuilder {
    mapping = new Dictionary<string, any>();

    constructor(queryStringKeyValues?: any[]) {
        if (queryStringKeyValues) {
            this.addQueryStringParams(queryStringKeyValues);
        }
    }

    addQueryStringParams(keyValueParams: any[]) {
        keyValueParams.forEach(pair => this.addQueryStringParam(pair.key, pair.value));
    }

    addQueryStringParamsInsideFilter(keyValueParams: any[]) {
        let result = this.getFilters(keyValueParams);
        this.addQueryStringParam('filter', result);
    }

    addEncodedQueryStringParamsInsideFilter(keyValueParams: any[]) {
        let result = this.getFilters(keyValueParams);
        const encoded = encodeURIComponent(result)
        this.addQueryStringParam('filter', encoded);
    }

    addQueryStringParamsInsideProject(project: string) {
        this.addQueryStringParam('project', project);
    }

    addQueryStringParam(key: string, value: any) {
        if (key == "" || typeof (value) == "string" && value == "") {
            return;
        }
        if (key != null && value != undefined && key != undefined && value != undefined) {
            this.mapping.addOrUpdate(key, value);
        }
    }

    buildUrl(baseUrl: string) {
        if (this.mapping.any()) {
            const pairs = this.mapping.iterator();
            baseUrl += `?${pairs[0].key}=${pairs[0].value}`;
            if (pairs.length > 1) {
                for (let index = 1; index < pairs.length; index++) {
                    const value = pairs[index].value
                    if(Array.isArray(value)){
                        for (let v of value ){
                            baseUrl += `&${pairs[index].key}=${v}`;
                        }
                    }else{
                        baseUrl += `&${pairs[index].key}=${value}`;

                    }
                }
            }
        }
        return baseUrl;
    }

    getFilters(keyValueParams: any[]) {
        return keyValueParams.filter(x => typeof x.value !== 'undefined' && x.value !== '')
            .map(m => { return `${m.key}=${m.value}` })
            .join(',');
    }
}



// WEBPACK FOOTER //
// ./src/app/models/utils/url-builder.model.ts